import { render, staticRenderFns } from "./HideFamilyDialog.vue?vue&type=template&id=3c861d62&"
import script from "./HideFamilyDialog.vue?vue&type=script&lang=js&"
export * from "./HideFamilyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports